/*
 * @Descripttion:
 * @Author: zhangtingjiang
 * @Date: 2019-11-29 10:13:24
 */
import Mock from 'mockjs'
import { param2Obj } from '@/utils'
let responseSuccessData = Mock.mock({
  'data|4-40': [
    { 'id|+1': 1, name: '@cname', 'sex|1': ['男', '女'], 'phone': /^1[385][1-9]\d{8}/, 'group|1': ['小学组', '中学组', '高中组', '大学组'], 'status|1-2': true }
  ]
})
export default [
  {
    path: '/api/getjudgelist',
    type: 'get',
    response: config => {
      let paramsObj = param2Obj(config.url)
      let limit = paramsObj.page
      let size = paramsObj.per_page
      let responseData = responseSuccessData.data.slice((limit - 1) * size, limit * size)
      return {
        status: 'success',
        total: responseSuccessData.data.length,
        data: responseData
      }
    }
  },
  {
    path: '/api/addjudge',
    type: 'post',
    response: config => {
      const lastIndex = responseSuccessData.data.length - 1
      const lastId = responseSuccessData.data[lastIndex].id
      const addId = lastId + 1
      const params = JSON.parse(config.body)
      params.id = addId
      responseSuccessData.data.push(params)
      return {
        status: 'success',
        msg: '添加评委成功！'
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/mocks/modules/propleManage/judge.js